var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3ed7d1de09b566b2e0dc635f502fe2f5aa354830"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["multisafe-inc@multisafe-inc"]={id:"3ed7d1de09b566b2e0dc635f502fe2f5aa354830"};
      